<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false">

    <md-dialog-content>
      <div class="md-layout">
        <div class="md-layout-item md-alignment-center">
          <div class="center-block">
            <md-icon class="complete-icon">check</md-icon>
          </div>
        </div>
      </div>
      <br>
      <slot/>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button :class="'md-raised md-primary ' + confirmButtonClass" @click="onConfirm">
        <md-icon>check</md-icon>
        <span>{{ mdConfirmText }}</span>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import LoadingSpinnerOverlay from "./LoadingSpinnerOverlay";

export default {
  name      : 'ConfirmModal',
  components: {LoadingSpinnerOverlay},
  props     : {
    mdConfirmText     : {
      type   : String,
      default: 'はい'
    },
    confirmButtonClass: {
      type   : String,
      default: null,
    },
  },
  methods   : {
    onConfirm() {
      this.$emit('update:mdActive', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.md-toolbar {
  min-height: 2em;
  padding: 0;
  align-content: flex-end;

  span {
    font-size: 18px;
  }
}

.center-block {
  width: 48px;
  margin: 0 auto;
}

.complete-icon {
  font-size: 36px !important;
  width: 48px;
  height: 48px;
  color: white !important;
  background: lightgreen;
  border-radius: 50%;
}
</style>
